import React, { useState, useEffect, useRef } from 'react';

const dotBase = {
  width: '12px',
  height: '12px',
  borderRadius: '50%',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  transition: 'background-color 0.2s ease',
};

const ImageRotator = ({ images, intervalMs = 5000, className = 'hero-image' }) => {
  const [index, setIndex] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setIndex((i) => (i + 1) % images.length);
    }, intervalMs);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [index, intervalMs, images.length]);

  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ display: 'grid', placeItems: 'center' }}>
        {images.map((img, i) => (
          <img
            key={img.src}
            className={className}
            src={img.src}
            alt={img.alt}
            aria-hidden={i !== index}
            style={{
              gridArea: '1 / 1',
              opacity: i === index ? 1 : 0,
              transition: 'opacity 0.6s ease-in-out',
              pointerEvents: i === index ? 'auto' : 'none',
            }}
          />
        ))}
      </div>
      <div
        style={{
          display: 'flex',
          gap: '0.5rem',
          justifyContent: 'center',
          marginTop: '1rem',
        }}
      >
        {images.map((img, i) => (
          <button
            key={img.src}
            type="button"
            aria-label={`Show ${img.alt}`}
            aria-current={i === index ? 'true' : 'false'}
            onClick={() => setIndex(i)}
            style={{
              ...dotBase,
              backgroundColor: i === index ? '#EEC643' : '#9792E3',
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageRotator;
